import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Menu from "../main/Menu";
import { axiosClient } from "../../helpers/axios";
import Header from "../main/Header";
import { useSelector } from "react-redux";
import ChatBot from "../chatBot/ChatBot"; // O tu ChatIaButton si usas ese

const MiddlewareAuth = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const auth = useSelector((state) => state.Login.auth);
  const token = ''; // Si luego lo tomas de Redux/LS, solo actualiza aquí

  // Configurar interceptor solo una vez
  useEffect(() => {
    const interceptor = axiosClient.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        if (error.response?.status === 401) {
          // Aquí podrías disparar logout global si quieres
        }
        return Promise.reject(error);
      }
    );

    // Simulación / hook para inicialización
    const timer = setTimeout(() => {
      setLoading(false);
    }, 400);

    return () => {
      clearTimeout(timer);
      axiosClient.interceptors.request.eject(interceptor);
    };
  }, []);

  // Pantalla de carga estilizada con tu branding
  if (loading) {
    return (
      <div className="w-screen h-screen flex flex-col items-center justify-center bg-cs-surface">
        <div className="mb-4 flex items-center gap-2">
          <img
            src="/logoB.png"
            alt="CargoSmart"
            className="h-8 w-auto object-contain"
          />
        </div>
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-cs-primary border-t-transparent" />
        <p className="mt-3 text-xs text-cs-muted tracking-wide">
          Loading your workspace...
        </p>
      </div>
    );
  }

  // Si no está autenticado → al login
  if (!auth || !auth.isAuth) {
    return <Navigate to="/login" />;
  }

  // Layout autenticado
  return (
    <div className="w-screen h-screen flex flex-col bg-cs-surface">
      {/* Top header */}
      <Header />

      {/* Body layout */}
      <div className="flex flex-row flex-1 overflow-hidden">
        {/* Sidebar */}
        <Menu />

        {/* Main content */}
        <main
          className="
            flex-1 h-full overflow-auto
            bg-cs-surface
            px-4 lg:px-6 py-4
          "
        >
          {children}
        </main>

        {/* Chat / IA helper (flotante / lateral) */}
        <div className=" xl:flex items-end pr-4 pb-4">
          <ChatBot />
          {/* Si usas otro:
            <ChatIaButton />
          */}
        </div>
      </div>
    </div>
  );
};

export default MiddlewareAuth;
